import ListValue from './listValue'

interface Props {
  options?: Array<Array<Number>>
  filteredMinPrice: number;
  filteredMaxPrice: number;
  setFilteredMinPrice(min: number): void;
  setFilteredMaxPrice(max: number): void;
  filterOnClick: boolean;
  formatNumber: Function;
}

const ListOptions = (props: Props) => {
  const {
    options,
    filteredMinPrice,
    filteredMaxPrice,
    formatNumber,
    setFilteredMinPrice,
    setFilteredMaxPrice,
    filterOnClick
  } = props

  return (
    <div className="content-wrapper">
      {options?.map((option: Array<Number>, key: number) => (
        <ListValue
          key={key}
          option={option}
          filteredMinPrice={filteredMinPrice}
          filteredMaxPrice={filteredMaxPrice}
          setFilteredMinPrice={setFilteredMinPrice}
          setFilteredMaxPrice={setFilteredMaxPrice}
          filterOnClick={filterOnClick}
          formatNumber={formatNumber}
        />
      ))}
    </div>
  )
}

export default ListOptions
